import { observer } from 'mobx-react-lite';

function AddressInfo({ address_line_1, address_line_2, address_line_3, street, city, landline, email }) {
    const full_address = [];

    if(address_line_1) { full_address.push(address_line_1); }
    if(address_line_2) { full_address.push(address_line_2); }
    if(address_line_3) { full_address.push(address_line_3); }
    if(street) { full_address.push(street); }
    if(city) { full_address.push(city); }

    return (
        <div>            
            <div className='row mb-10'>
                <div className="col-md-3">Address</div>
                <div className="ml-auto col-md-9">{full_address.join(', ')}</div>
            </div>            
        
            <div className='row mb-10'>
                <div className="col-md-3">Contact phone</div>
                <div className="ml-auto col-md-9">{landline}</div>
            </div>            
        
            <div className='row mb-10'>
                <div className="col-md-3">Contact email</div>
                <div className="ml-auto col-md-9">{email}</div>
            </div> 
        </div>    
    );
}

export default observer(AddressInfo);
